module.exports = __webpack_public_path__ + "img/pic_标准.ee17d19e.png";